"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTimeOnlyString = exports.isValidDateTimeTimeString = exports.isValidDateTimeDateString = exports.isValidDateTimeDateAndTimeString = exports.getTodayEnglishDateOnlyString = exports.convertTimeOnlyStringToDate = void 0;
const dateConstants_1 = require("./dateConstants");
const datetime_1 = require("./datetime");
const convertTimeOnlyStringToDate = (timeOnlyString, dateOnlyString) => {
    // This workflow is needed to generate a valid Date object
    return (0, datetime_1.toDate)(`${dateOnlyString}T${timeOnlyString}`);
};
exports.convertTimeOnlyStringToDate = convertTimeOnlyStringToDate;
const getTodayEnglishDateOnlyString = () => {
    const today = (0, datetime_1.setDateLocalized)('en');
    return (0, datetime_1.formatDate)(dateConstants_1.normalizedDateFormat, today);
};
exports.getTodayEnglishDateOnlyString = getTodayEnglishDateOnlyString;
const isValidDateTimeDateAndTimeString = (value) => (0, datetime_1.isAwsDateString)(value);
exports.isValidDateTimeDateAndTimeString = isValidDateTimeDateAndTimeString;
// Format e.g., 1990-02-10
const isValidDateTimeDateString = (value) => (0, datetime_1.isValidDate)(value, dateConstants_1.normalizedDateFormat, true);
exports.isValidDateTimeDateString = isValidDateTimeDateString;
// Format e.g., 02:01:00.000
const isValidDateTimeTimeString = (value) => isTimeOnlyString(value);
exports.isValidDateTimeTimeString = isValidDateTimeTimeString;
function isTimeOnlyString(str) {
    const regex = /^([0-1][0-9]|[2][0-3]):([0-5][0-9]:00.000)$/;
    return regex.test(str);
}
exports.isTimeOnlyString = isTimeOnlyString;
